import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const addUserToWorkspaceMutation = loader(
  'src/pages/workspace/WorkspaceDetailsPage.addUser.graphql',
);
const updateWorksapceMutation = loader(
  'src/pages/workspace/WorkspaceDetailsPage.updateWorkspace.graphql',
);

export const useWorkspaceMutations = () => {
  const [addUserToWorkspace] = useMutation(addUserToWorkspaceMutation);
  const [updateWorkspaceMutation] = useMutation(updateWorksapceMutation);
  const addUser = async ({ userId, workspaceId, onComplete = () => {} }) => {
    await addUserToWorkspace({
      variables: { id: workspaceId, userId, accessLevel: 'USER' },
    }).then(() => onComplete());
  };
  const updateWorkspace = async ({ id, observationTemplateId }) => {
    await updateWorkspaceMutation({ variables: { id, observationTemplateId } });
  };
  return { addUser, updateWorkspace };
};
